import React, { useMemo } from 'react';
import type { User } from '../types';

type UserTableRowProps = {
  hidden?: boolean;
  isSelected: boolean;
  officeName: string;
  user: User;
  onUserSelection: (userId: number, isSelected: boolean) => void;
};

const UserTableRow = ({ hidden, isSelected, officeName, user, onUserSelection } : UserTableRowProps) => {
  const inputId = useMemo(() => `permissions_other_user_ids_${user.id}`, [user.id]);
  return (
    <tr hidden={hidden} key={user.id}>
      <td className="pt-2 pb-1">
        <label className="fw-semibold clickable d-flex gap-2 align-items-center" htmlFor={inputId}>
          <div>
            <input
              checked={isSelected}
              id={inputId}
              name="user[permissions_other_user_ids][]"
              type="checkbox"
              value={user.id}
              onChange={e => onUserSelection(user.id, e.target.checked)}
            />
          </div>
          <div>
            {user.firstName} {user.lastName}
          </div>
        </label>
      </td>
      <td className="py-0">
        <label className="fw-semibold clickable" htmlFor={inputId}>
          {officeName}
        </label>
      </td>
    </tr>
  );
};

export default UserTableRow;
